"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.objekt_technik = void 0;
const leaflet_1 = __importDefault(require("leaflet"));
exports.objekt_technik = leaflet_1.default.icon({
    iconUrl: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAFcSURBVFhH7ZYhUsRAEEVTKCQSiUQikUgkEskRkEhusEfgCEgkEssNOAISCf3Y/KreppPMTEZReVWvdjc7md8z06ndYWOjklPzyXwdvTWnODGvzMvfTx24Nj/N7yAhHoIp0o95NldB+JfpJ8U7M/Ji+jF8PjabqQm/Mf2YGM5cZ/u3ZUyFcxQXZmRnagw9EsOZKys8ZSpcZkX47fff+7keuSCOxtcMOr727N7HV6AZ2YV7kybUXH7MImyXVhRlRaxMsNrsKfF+mLOLWtr2qIooCWdsfGT/QIdSZbxZO5EVx7Us/M3kOvNxBOdmEVkRQBGslCby32UeNFoLsYjIXBGrw4WKYBsj7ER2HN3CBUXoWRZTDdc9PKM0nGvdqQmX3WgJl6upPfM4Dptpbbg4HqtpDRfxPixmbbiI9+MivcJFnAdnyX4RW8OFnwsXmfwHs4LicEERD/u3G/+WYfgBsaX7xwDG3/MAAAAASUVORK5CYII=",
    iconSize: [32, 32],
});
